export default "__VITE_ASSET__CUA$4rEB__"